import { Box } from '@mui/material';
import Headline6 from 'components/elements/Headline6';
import ContentNormal from 'components/elements/ContentNormal';
import { useContext } from 'react';
import { AppContext } from 'contexts/AppContext';

function OrderTrackingHelp() {
  const { styleGuide, brandData } = useContext(AppContext);

  const contactEmail = brandData?.contactEmail || 'support@upgrader.dk'

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: styleGuide.color2,
        padding: { xs: 3, sm: 4 },
        paddingBottom: 8,
        gap: 1,
        borderRadius: 4,
        minWidth: 250,
      }}
    >
      <Headline6 style={{ marginBottom: 10 }} translationKey="_PROFILE_ORDER_CONTACT_HEADLINE_" fallbackText="Har du spørgsmål til din ordre?" />
      <ContentNormal translationKey="_PROFILE_ORDER_CONTACT_INFO_" fallbackText="Du er altid velkommen til at kontakte os." />
      <Box marginTop={2} display={'flex'} flexDirection={'column'} gap={1}>
        <a href={`mailto:${contactEmail}`} style={{ textDecoration: 'none' }}>
          <ContentNormal fallbackText={contactEmail} />
        </a>
        {brandData.contactPhone && <ContentNormal fallbackText={brandData.contactPhone} />}
      </Box>
    </Box>
  );
}

export default OrderTrackingHelp;